/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
let activeCapability: string | null = null;

export const setCapability = (capability: string | null): void => {
	activeCapability = capability;
};

export const getCapability = (): string | null => activeCapability;
